import {
    faAlignJustify,
    faAlignLeft,
    faChevronDown,
    faClipboardCheck,
    faHandHoldingUsd,
    faListAlt,
    faListUl,
    faTasks,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../../../Context/User";
import { ACESSOS } from "../../../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../../../Validations/UsuarioTela";
import { IComponentModal } from "../../../../Modais/IModalComponent";
import {
    SubCategoria,
    SubCategoriaHeader,
} from "../GestaoCadastro/SubCategoria";
import JornadaEtapa from "../GestaoCadastro/JornadaEtapa";
import PerfilFinanceiro from "../GestaoCadastro/PerfilFinanceiro";

interface IEtapasCategorias {
    SetShow: Dispatch<SetStateAction<boolean>>;
    show: boolean;
    SetModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    Modal: IComponentModal | undefined;
}

export function EtapasCategorias(props: IEtapasCategorias) {
    const { UserInfor } = useUserInfor();

    return (
        <div className="card">
            <div className="card-header p-7" id="headingTwo">
                <span className="mb-0 d-flex justify-content-center align-items-center span-style">
                    <button
                        className="d-flex justify-content-center align-items-center w-100 border-0 buttonBgWhite"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                    >
                        <FontAwesomeIcon className="mr-2" icon={faListUl} />
                        Etapas e Categorias
                        <FontAwesomeIcon
                            className="ml-2"
                            size={"sm"}
                            icon={faChevronDown}
                        />
                    </button>
                </span>
            </div>
            <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
            >
                {/* <div className="menu-submenu menu-submenu-classic menu-submenu-left"> */}
                <ul className="menu-subnav pt-3">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.CATEGORIA_ATENDIMENTO.GESTAO
                            .ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <div className="menu-item a-hover-none">
                            <NavLink
                                to={
                                    ACESSOS.GERAL.TELAS.CATEGORIA_ATENDIMENTO
                                        .GESTAO.DS_PATH
                                }
                                activeClassName="menu-link-active"
                                className="menu-link a-hover-none"
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faAlignJustify} />
                                </span>
                                <span className="textBlue">
                                    Categoria de Atendimento
                                </span>
                            </NavLink>
                        </div>
                    )}
                </ul>
                <ul className="menu-subnav">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.MODAIS.SUBCATEGORIA.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <a
                                href="#/"
                                className="menu-link a-hover-none"
                                onClick={() => {
                                    props.SetShow(true);
                                    props.SetModal({
                                        Component: SubCategoria,
                                        customHeader: SubCategoriaHeader(),
                                        size: "lg",
                                    });
                                }}
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faAlignLeft} />
                                </span>
                                <span className="textBlue">Subcategoria</span>
                            </a>
                        </li>
                    )}
                </ul>
                <ul className="menu-subnav">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.ATRIBUTOS_ETAPA.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <NavLink
                                to={ACESSOS.GERAL.TELAS.ATRIBUTOS_ETAPA.DS_PATH}
                                exact
                                activeClassName="menu-link-active"
                                className="menu-link a-hover-none"
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faListAlt} />
                                </span>
                                <span className="textBlue">
                                    Atributos por Etapa
                                </span>
                            </NavLink>
                        </li>
                    )}
                </ul>

                <ul className="menu-subnav">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.STATUS_ETAPA.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <NavLink
                                to={ACESSOS.GERAL.TELAS.STATUS_ETAPA.DS_PATH}
                                exact
                                activeClassName="menu-link-active"
                                className="menu-link a-hover-none"
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faTasks} />
                                </span>
                                <span className="textBlue">
                                    Status por Etapa
                                </span>
                            </NavLink>
                        </li>
                    )}
                </ul>

                <ul className="menu-subnav">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.MODAIS.SUBCATEGORIA.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <a
                                href="#/"
                                className="menu-link a-hover-none"
                                onClick={() => {
                                    props.SetShow(true);
                                    props.SetModal({
                                        Component: JornadaEtapa,
                                        headerComponent: "Jornada da Etapa",
                                        collapseForm: true,
                                        size: "lg",
                                    });
                                }}
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faClipboardCheck} />
                                </span>
                                <span className="textBlue">
                                    Jornada da Etapa
                                </span>
                            </a>
                        </li>
                    )}
                </ul>

                <ul className="menu-subnav pb-3">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.MODAIS.SUBCATEGORIA.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item a-hover-none">
                            <a
                                href="#/"
                                className="menu-link a-hover-none"
                                onClick={() => {
                                    props.SetShow(true);
                                    props.SetModal({
                                        Component: PerfilFinanceiro,
                                        headerComponent: "Perfil Financeiro",
                                        collapseForm: true,
                                        size: "lg",
                                    });
                                }}
                            >
                                <span className="svg-icon menu-icon">
                                    <FontAwesomeIcon icon={faHandHoldingUsd} />
                                </span>
                                <span className="textBlue">
                                    Perfil Financeiro
                                </span>
                            </a>
                        </li>
                    )}
                </ul>
                {/* </div> */}
            </div>
        </div>
    );
}
